import React, { type CSSProperties, useMemo } from 'react';

import { TableTBodyWrapper } from '@wp-block-builder/block-helpers/table-layout-components';
import { useGlobalConfiguration } from '@wp-block-builder/stores/WaypointDocumentStore/useGlobalStyles';
import useTemplatedColor from '@wp-block-builder/stores/WaypointDocumentStore/useTemplatedColor';

import cleanupCssStyle from './helpers/cleanupCssStyle';

type Props = {
  children: JSX.Element | JSX.Element[];
};
export default function CanvasBlock({ children }: Props) {
  const { canvasStyle } = useGlobalConfiguration();
  const backgroundColor = useTemplatedColor({
    defaultColor: '#FFFFFF',
    color: canvasStyle.backgroundColor,
    template: canvasStyle.backgroundColorTemplate,
  });
  const canvasSx = useMemo<CSSProperties>(
    () => ({
      ...(cleanupCssStyle(canvasStyle) as CSSProperties),
      backgroundColor,
      maxWidth: canvasStyle.maxWidth || '600px',
      minHeight: canvasStyle.minHeight || '48px',
    }),
    [canvasStyle, backgroundColor]
  );

  return (
    <TableTBodyWrapper style={canvasSx}>
      <tr>
        <td>{children}</td>
      </tr>
    </TableTBodyWrapper>
  );
}
